import React, { useState } from 'react';
import OverlayWrapper from './OverlayWrapper';
import { getConfiguration } from '../data/utils/configuration';
import { isBotAgent } from '../data/sport-utils';
import { getLabel } from '../data/labels';

const pages = [
    {
        images: [
            `${process.env.PUBLIC_URL}/assets/images/tutorial/Immagine 6.png`,
            `${process.env.PUBLIC_URL}/assets/images/tutorial/Immagine 5.png`
        ],
        title: 'Selettore menù sport',
        text: 'Selezionando sul menu indicato, potrai abilitare il menù sportivo scorrevole, oppure mantenere quello classico a tendina.',
    },
    {
        images: [
            `${process.env.PUBLIC_URL}/assets/images/tutorial/Immagine 13.png`
        ],
        title: 'Imposta giocata veloce',
        text: 'Selezionando sul menu indicato, potrai impostare la giocata veloce: selezionando sulla quota la scommessa verrà immediatamente piazzata.',
    },
    {
        images: [
            `${process.env.PUBLIC_URL}/assets/images/tutorial/Immagine 21.png`,
            `${process.env.PUBLIC_URL}/assets/images/tutorial/Immagine 20.png`,
        ],
        title: 'Bottoni social',
        text: 'Scegli se mostrare i bottoni social per condividere match e tornei.',
    },
    {
        images: [
            `${process.env.PUBLIC_URL}/assets/images/tutorial/Immagine 28.png`,
            `${process.env.PUBLIC_URL}/assets/images/tutorial/Immagine 29.png`,
        ],
        title: 'Mostra banner',
        text: 'Scegli se mostrare il carosello con i banner.',
    },
    {
        images: [
            `${process.env.PUBLIC_URL}/assets/images/tutorial/Immagine 7.png`,
            `${process.env.PUBLIC_URL}/assets/images/tutorial/Immagine 8.png`
        ],
        title: 'Ordina categoria',
        text: 'Selezionando sul menu indicato, potrai ordinare le categorie per nome oppure per ordine di importanza.',
    },
    {
        images: [
            `${process.env.PUBLIC_URL}/assets/images/tutorial/Immagine 10.png`,
            `${process.env.PUBLIC_URL}/assets/images/tutorial/Immagine 9.png`
        ],
        title: 'Mostra tornei in evidenza',
        text: 'Selezionando sul menu indicato, potrai scegliere se mostrare o meno i tornei in evidenza (quelli più giocati).',
    },
    {
        images: [
            `${process.env.PUBLIC_URL}/assets/images/tutorial/Immagine 19.png`
        ],
        title: 'Eventi live dentro prematch',
        text: 'Selezionando sul menu indicato, potrai scegliere se visualizzare gli eventi live nella sezione prematch.',
    },
    {
        images: [
            `${process.env.PUBLIC_URL}/assets/images/tutorial/Immagine 22.png`,
            `${process.env.PUBLIC_URL}/assets/images/tutorial/Immagine 23.png`
        ],
        title: 'Menu categorie con menù a tendina',
        text: 'Scegli se mostrare il menu delle categorie come menù a tendina (chiusi di default).',
    },
    {
        images: [
            `${process.env.PUBLIC_URL}/assets/images/tutorial/Immagine 25.png`,
            `${process.env.PUBLIC_URL}/assets/images/tutorial/Immagine 24.png`
        ],
        title: 'Categorie live',
        text: 'Scegli se mostrare il selettore delle categorie live o se mostrarle sempre tutte.',
    },
    {
        images: [
            `${process.env.PUBLIC_URL}/assets/images/tutorial/Immagine 11.png`,
            `${process.env.PUBLIC_URL}/assets/images/tutorial/Immagine 12.png`
        ],
        title: 'Selettore compatto',
        text: 'Selezionando sul menu indicato, potrai scegliere se visualizzare le scommesse su una oppure su due righe.',
    },
    {
        images: [
            `${process.env.PUBLIC_URL}/assets/images/tutorial/Immagine 15.png`,
            `${process.env.PUBLIC_URL}/assets/images/tutorial/Immagine 14.png`
        ],
        title: 'Scommessa sotto evento',
        text: 'Scegli se visualizzare le scommesse sotto l\'evento oppure di fianco.',
    },
    {
        images: [
            `${process.env.PUBLIC_URL}/assets/images/tutorial/Immagine 17.png`,
            `${process.env.PUBLIC_URL}/assets/images/tutorial/Immagine 16.png`
        ],
        title: 'Quote scorrevoli',
        text: 'Scegli se visualizzare le quote in maniera scorrevole oppure in cascata.',
    },
    {
        images: [
            `${process.env.PUBLIC_URL}/assets/images/tutorial/Immagine 27.png`,
            `${process.env.PUBLIC_URL}/assets/images/tutorial/Immagine 26.png`
        ],
        title: 'Mostra selettore scommessa',
        text: 'Scegli se visualizzare il selettore scommessa oppure mostrare sempre tutte le scommesse del gruppo.',
    }
];

function showTutorial(conf) {
    return !isBotAgent() && !conf.nas && conf.tutm && localStorage.getItem('xs_show_tutorial') == null;
}

export default function SettingsTutorial(props) {
    const conf = getConfiguration();
    const singlePageMode = props.index != null;
    const [toggled, setToggled] = useState(singlePageMode || showTutorial(conf));
    const [pageIndex, setPageIndex] = useState(singlePageMode ? props.index : 0);

    if (!toggled) {
        return null;
    }

    function handleClose() {
        localStorage.setItem('xs_show_tutorial', false)
        setToggled(false);
    }

    const page = pages[pageIndex];

    return (
        <OverlayWrapper id="xs-settings-tutorial-overlay">
            <div className="xs_settingsTutorial z-30 absolute container top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-black/70">
                <div className="h-[80%] w-[90%] px-8 py-4 grid grid-rows-[1fr_70%_1fr_1fr] gap-4 items-center bg-cc1 rounded-md">
                    {!singlePageMode &&
                        <div className="w-full flex items-center justify-start font-medium text-md text-cs1">{pageIndex + 1} / {pages.length}</div>
                    }
                    <div className="h-full flex flex-col">
                        {page.images.length > 0 &&
                            <div className="h-[70%] flex flex-col items-center justify-start">
                                {page.images.length === 2 ?
                                    <div className="flex flex-col items-center">
                                        <img src={page.images[0]} alt='' />
                                        <i className="bi-arrow-down-up font-bold text-[40px] text-cs4" />
                                        <img src={page.images[1]} alt='' />
                                    </div>
                                    :
                                    <img src={page.images[0]} alt='' />
                                }
                            </div>
                        }
                        <div className="h-[30%] flex flex-col items-center justify-start">
                            <div className="mt-2 w-full flex items-center justify-start font-medium text-md text-cs4 uppercase">{page.title}</div>
                            <div className="w-full flex items-center justify-start font-medium text-md text-cs1">{page.text}</div>
                        </div>
                    </div>
                    {singlePageMode ?
                            <button className="h-[60px] w-full font-medium text-md bg-cs4 text-cs1 rounded-md" onClick={props.toggle}>{getLabel('tutorial.close')}</button>
                        :
                        <>
                            <div className="w-full grid grid-cols-2 gap-4 items-center justify-between">
                                <button className="h-[60px] w-full font-medium text-md bg-cc3 text-cs1 rounded-md" onClick={handleClose}>{getLabel('tutorial.skip')}</button>
                                {pageIndex < (pages.length - 1) ?
                                    <button className="h-[60px] w-full font-medium text-md bg-cs4 text-cs1 rounded-md" onClick={() => setPageIndex(prev => prev + 1)}>{getLabel('tutorial.next')}</button>
                                    :
                                    <button className="h-[60px] w-full font-medium text-md bg-cs4 text-cs1 rounded-md" onClick={handleClose}>{getLabel('tutorial.last')}</button>
                                }
                            </div>
                            {pageIndex > 0 ?
                                <div className="text-md font-medium text-cs1" onClick={() => setPageIndex(prev => prev - 1)}>{getLabel('general.back')}</div>
                                :
                                <span></span>
                            }
                        </>
                    }
                </div>
            </div>
            {!singlePageMode &&
                <div className="z-30 absolute container top-[4px] right-[4px] h-[60px] w-[60px] flex items-center justify-center bg-cs1 border border-4 border-cs4 rounded-full">
                    <i className="bi-list text-3xl text-black" />
                </div>
            }
        </OverlayWrapper>
    );
}

export function SettingsTutorialSinglePage(props) {
    const page = pages[props.index];

    return (
        <OverlayWrapper id="xs-settings-tutorial-overlay">
            <div className="xs_tutorialPage z-30 absolute container top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-black/70">
                <div className="h-[80%] w-[90%] px-8 py-4 flex flex-col items-center justify-between bg-cc1 rounded-md">
                    <div>
                        {page.images.length > 0 &&
                            <div className="my-2 flex flex-col items-center">
                                {page.images.length === 2 ?
                                    <div className="flex flex-col items-center">
                                        <img src={page.images[0]} alt='' />
                                        <i className="bi-arrow-down-up font-bold text-[40px] text-cs4" />
                                        <img src={page.images[1]} alt='' />
                                    </div>
                                    :
                                    <img src={page.images[0]} alt='' />
                                }
                            </div>
                        }
                        <div className="my-2 flex flex-col items-center">
                            <div className="mt-2 w-full flex items-center justify-start font-medium text-md text-cs4 uppercase">{page.title}</div>
                            <div className="w-full flex items-center justify-start font-medium text-md text-cs1">{page.text}</div>
                        </div>
                    </div>
                    <button className="h-[60px] w-full my-2 font-medium text-md bg-cs4 text-cs1 rounded-md" onClick={props.toggle}>{getLabel('tutorial.close')}</button>
                </div>
            </div>
        </OverlayWrapper>
    );
}
